import { CapacityResponse } from '@features/desks/services/OfficeCapacityService';
import React, { useMemo } from "react";

export function WithOfficeCapacity(capacity?: CapacityResponse): number {
  const cap = useMemo(() => {
    if (capacity) {
      const spacesAvailable = capacity.capacity - Math.max(capacity.amUsed, capacity.pmUsed);
      if (spacesAvailable < 1 && capacity.amUsed !== capacity.pmUsed) {
        return 0.5;
      } else {
        return spacesAvailable;
      }
    }
    return 0;
  }, [capacity]);

  return cap;
}

export function OfficeUsageWithHalfSpace(props: { availableSpaces: number }) {
  return <>
    {props.availableSpaces === 0.5 ? <>
      <span>&#189;</span>
    </> : <>
      {props.availableSpaces}
    </>}
  </>
}
